import { eventChannel } from 'redux-saga'
import { call, put, takeEvery } from 'redux-saga/effects'

import {
  CHECK_AUTH_STATUS_SUCCESS,
  LOG_IN_SUCCESS,
  REGISTER_SUCCESS,
  USER_ROOMS,
  ROOM_METADATA,
  ROOM_MESSAGES,
} from 'actionTypes'
import * as api from 'api'

function* subscribeToUserRooms() {
  const channel = eventChannel(api.subscribeToUserRooms)
  yield takeEvery(channel, function* newMessages(rooms) {
    yield put({
      type: USER_ROOMS,
      rooms,
    })
  })
}

let roomChannels = {}

function* subscribeToRoomMetadata({ rooms }) {
  const roomIds = Object.keys(rooms)
  const newRoomIds = roomIds.filter(
    roomId => !Object.keys(roomChannels).includes(roomId)
  )
  const oldRoomIds = Object.keys(roomChannels).filter(roomId =>
    roomIds.includes(roomId)
  )

  for (const i in newRoomIds) {
    const roomId = newRoomIds[i]
    roomChannels[roomId] = eventChannel(api.subscribeToRoomMetadata(roomId))
    yield takeEvery(roomChannels[roomId], function* newMessages(metadata) {
      yield put({
        type: ROOM_METADATA,
        metadata,
        roomId,
      })
    })
  }

  oldRoomIds.forEach(id => roomChannels[id].close())
}

function* resetNotificationCounter({ roomId }) {
  yield call(api.resetNotificationCounter, roomId)
}

function* saga() {
  yield takeEvery(
    [
      LOG_IN_SUCCESS,
      REGISTER_SUCCESS,
      action => action.type === CHECK_AUTH_STATUS_SUCCESS && action.user,
    ],
    subscribeToUserRooms
  )
  yield takeEvery(USER_ROOMS, subscribeToRoomMetadata)
  yield takeEvery(ROOM_MESSAGES, resetNotificationCounter)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/chat.js